<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="height: 100%">
      <el-dialog title="防汛值班" :visible.sync="dialogVisible" :modal="false" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="24">
            <addressTree @obj="objdata" @close="treeClose" :currentdata="currentData"></addressTree>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <treepop @obj="objdata_bm" @close="treeClose_bm" :label="label_bm" :datalist="bumenList" :currentdata="currentDatabm"></treepop>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class='personnel'>
            <treepop @obj="objdata_ry" @close="treeClose_ry" :label="label_ry" :datalist="zbrylist" :currentdata="currentDatary"></treepop>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class='personnel'>
            <treepop @obj="objdata_ld" @close="treeClose_ld" :label="label_ld" :datalist="zbldList" :currentdata="currentDatald"></treepop>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="状态" prop="zbzt">
              <el-select v-model.trim="ruleForm.zbzt" class="from-el-input" placeholder="状态">
                <el-option v-for="(item,i) in fxzbztList" :key="i" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="开始时间" prop="addzbkssj">
              <el-date-picker v-model.trim="ruleForm.addzbkssj" @change="ksjsChange" class="from-el-input-item"
                value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item type="type" label="结束时间" prop="addzbjssj">
              <el-date-picker @change="jsjsChange" v-model.trim="ruleForm.addzbjssj" class="from-el-input-item"
                value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round v-if="states=='xz'" type="primary" @click="deteRmine('ruleForm','xz')">保 存</el-button>
            <el-button round v-if="states=='bj'" type="primary" @click="deteRmine('ruleForm','bj')">保 存</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    ydbjbxxQuery,
    fxzbSave,
    fxzbUpdate,
    dictioninfo,
    orglist,
    userlist
  } from "@/api/api";
  import treepop from '@/components/mangement/treepopup.vue';
  import addressTree from '@/components/mangement/popupaddressTree.vue';
  export default {
    props: {
      mystate: Array,
    },
    data() {
      return {
        dialogVisible: true, //弹出框显示
        pickerOptions: { //时间插件设置
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        ruleForm: {
          ydbName: '', //淤地坝名称
          ydbCode: '', //淤地坝编码
          bumen: '', //部门名称
          bumenid: '', //部门id
          zbry: '', //值班人员
          zbryid: '', //值班人员id
          zbld: '', //值班领导
          zbldid: '', //值班领导id
          addzbkssj: this.getNowTimes(), //值班开始日期
          addzbjssj: this.getNowTimes(), //值班结束时间
          zbzt: '',
        },
        rules: {
          ydbName: [{
            required: true,
            message: '请输入必填项',
            trigger: 'change'
          }, ],
          bumen: [{
            required: true,
            message: '请选择必填项',
            trigger: 'change'
          }, ],
          zbry: [{
            required: true,
            message: '请选择必填项',
            trigger: 'change'
          }, ],
          zbld: [{
            required: true,
            message: '请选择必填项',
            trigger: 'change'
          }, ],
          zbzt: [{
            required: true,
            message: '请输入必填项',
            trigger: 'change'
          }, ],
          addzbkssj: [{
            required: true,
            message: '请选择必填项',
            trigger: 'blur'
          }, ],
          addzbjssj: [{
            required: true,
            message: '请选择必填项',
            trigger: 'blur'
          }, ],
        },
        states: '',
        fxzbztList: [], //防汛值班状态list
        bumenList: [], //部门tree
        zbrylist: [], //值班人员tree
        zbldList: [], //值班领导tree
        row: null,
        currentData: '',
        currentDatabm: '',
        currentDatary: '',
        currentDatald: '',

        label_bm: '部门',
        label_ry: '值班人员',
        label_ld: '值班领导',
        current_bm: '',
      }
    },
    components: {
      addressTree,
      treepop
    },
    mounted() {
      this.getfxzbztinfo();

      this.states = this.mystate[0];
      this.row = this.mystate[1];
      if (this.states == 'bj') {
        this.currentData = this.mystate[1].ydbName; //淤地坝名称
        this.currentDatabm = this.mystate[1].ydbGldw; //管理单位
        this.currentDatary = this.mystate[1].ydbZbryMz; //值班人员名字
        this.currentDatald = this.mystate[1].ydbZbfzrMz; //值班负责人名字

        this.ruleForm.ydbName = this.mystate[1].ydbName; //淤地坝名称
        this.ruleForm.ydbCode = this.mystate[1].ydbCode; //淤地坝编号
        this.ruleForm.bumen = this.mystate[1].ydbGldw; //管理单位
        this.ruleForm.bumenid = this.mystate[1].ydbGldwId; //管理单位id
        this.ruleForm.zbry = this.mystate[1].ydbZbryMz; //值班人员名字
        this.ruleForm.zbryid = this.mystate[1].ydbZbryId; //值班人员名字id
        this.ruleForm.zbld = this.mystate[1].ydbZbfzrMz; //值班负责人名字
        this.ruleForm.zbldid = this.mystate[1].ydbZbfzrId; //值班负责人名字id
        this.ruleForm.addzbkssj = this.mystate[1].ydbZbkssj; //开始时间
        this.ruleForm.addzbjssj = this.mystate[1].ydbZbjssj; //结束时间

        if (this.mystate[1].status === 0) {
          this.ruleForm.zbzt = '已执行'; //状态
        } else {
          this.ruleForm.zbzt = '未执行'; //状态
        }
        console.log(this.ruleForm.zbzt)
      }

      orglist({}).then((res) => {
        this.bumenList = res.data;
      });
    },
    methods: {
      //获取防汛值班状态数字字典
      getfxzbztinfo() {
        let params = {
          type: 'fxzb',
          code: 'state'
        };
        dictioninfo(params).then((res) => {
          this.fxzbztList = res.data;
        })
      },
      list(params) {
        let _this = this;
        ydbjbxxQuery(params).then((res) => {
          if (res.data.length !== 1) {
            _this.$notify({
              title: "提示",
              message: "请选择淤地坝",
              type: "warning"
            });
          } else {
            _this.ruleForm.ydbCode = res.data[0].ydbCode;
            _this.ruleForm.ydbName = res.data[0].ydbName;
          }
        })
      },
      objdata(data) {
        let params = {
          ydbCode: data.ydbCode
        };
        this.list(params);
      },
      treeClose() {},
      objdata_bm(data) {
        let _this = this;
        this.zbrylist = [];
        this.current_bm = data.name;
        this.ruleForm.bumen = data.name;
        this.ruleForm.bumenid = data.id;
        userlist({}).then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            if (this.current_bm === res.data[i].deptName) {
              let mmm = res.data[i];
              mmm.name = res.data[i].username;
              _this.zbrylist.push(mmm);
            }
          }
        });
      },
      treeClose_bm() {
        // this.treeClose_ry();
        // this.treeClose_ld();
      },
      objdata_ry(data) {
        this.zbldList = [];
        this.ruleForm.zbry = data.name;
        this.ruleForm.zbryid = data.id;
        for (let i = 0; i < this.zbrylist.length; i++) {
          if (data.name !== this.zbrylist[i].name) {
            this.zbldList.push(this.zbrylist[i]);
          }
        }
      },
      treeClose_ry() {},
      objdata_ld(data) {
        this.ruleForm.zbld = data.name;
        this.ruleForm.zbldid = data.id;
      },
      treeClose_ld() {},
      ksjsChange() {
        if (new Date(this.ruleForm.addzbjssj) <= new Date(this.ruleForm.addzbkssj)) {
          this.$notify({
            title: '提示',
            message: '值班开始时间不能小于结束时间！',
            type: 'success'
          });
          this.ruleForm.addzbjssj = '';
        }
      },
      jsjsChange() {
        if (new Date(this.ruleForm.addzbjssj) <= new Date(this.ruleForm.addzbkssj)) {
          this.$notify({
            title: '提示',
            message: '值班结束时间不能小于开始时间！',
            type: 'success'
          });
          this.ruleForm.addzbjssj = '';
        }
      },
      getNowTimes() {
        var date = new Date();
        this.year = date.getFullYear();
        this.month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        this.date = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        this.hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        this.minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        this.second = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        this.milliSeconds = date.getMilliseconds();
        var currentTime = this.year + '-' + this.month + '-' + this.date + ' ' + this.hour + ':' + this.minute
        return currentTime
      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          "dialogVisible": this.dialogVisible
        })
      },
      deteRmine(formName, states) { //确定
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (states == 'xz') {
              let params = {
                ydbName: this.ruleForm.ydbName, //淤地坝名称
                ydbCode: this.ruleForm.ydbCode, //淤地坝编号
                ydbGldw: this.ruleForm.bumen, //管理单位
                ydbGldwId: this.ruleForm.bumenid, //管理单位id
                ydbZbryMz: this.ruleForm.zbry, //值班人员名字
                ydbZbryId: this.ruleForm.zbryid, //值班人员名id
                ydbZbfzrMz: this.ruleForm.zbld, //值班负责人名字
                ydbZbfzrId: this.ruleForm.zbldid, //值班负责人id
                ydbZbkssj: this.ruleForm.addzbkssj, //开始时间
                ydbZbjssj: this.ruleForm.addzbjssj, //结束时间
                status: this.ruleForm.zbzt, //值班状态
              };
              fxzbSave(params).then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: "提交成功",
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.$emit("adddata", {
                    dialogVisible: this.dialogVisible
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            } else {
              console.log(this.ruleForm.zbzt)
              // let zhuangtai;
              // if (this.ruleForm.zbzt === '已执行') {
              //   zhuangtai = 0;
              // } else {
              //   zhuangtai = 1;
              // }
              let params = {
                ydbName: this.ruleForm.ydbName, //淤地坝名称
                ydbCode: this.ruleForm.ydbCode, //淤地坝编号
                ydbGldw: this.ruleForm.bumen, //管理单位
                ydbGldwId: this.ruleForm.bumenid, //管理单位id
                ydbZbryMz: this.ruleForm.zbry, //值班人员名字
                ydbZbryId: this.ruleForm.zbryid, //值班人员名id
                ydbZbfzrMz: this.ruleForm.zbld, //值班负责人名字
                ydbZbfzrId: this.ruleForm.zbldid, //值班负责人id
                ydbZbkssj: this.ruleForm.addzbkssj, //开始时间
                ydbZbjssj: this.ruleForm.addzbjssj, //结束时间
                status: this.ruleForm.zbzt, //值班状态
                id: this.row.id
              };
              fxzbUpdate(params).then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: "提示",
                    message: "提交成功",
                    type: "success"
                  });
                  this.dialogVisible = false;
                  this.$emit("bjadddata", {
                    dialogVisible: this.dialogVisible
                  });
                } else {
                  this.$notify({
                    title: "提示",
                    message: res.message,
                    type: "warning"
                  });
                }
              })
            }
          }
        });
      },
    },
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 700px;
  }

  >>>.el-dialog__body {
    height: 450px;
    overflow: auto;
  }

  .trees {
    width: 98%;
    float: left;
    max-height: 300px;
    height: 60px;
    line-height: 30px;
    padding-left: 2%;
    margin-top: 5px;
  }

  .treebox {
    width: 100%;
    margin: 0;
  }
</style>
